import { ImagePlus, Upload, X } from "lucide-react";

type ProofUploadZoneProps = {
  proofImage: { file: File; preview: string } | null;
  onPaste: (e: React.ClipboardEvent) => void;
  onDrop: (e: React.DragEvent) => void;
  onRemove: () => void;
  fileInputRef: React.RefObject<HTMLInputElement | null>;
};

export function ProofUploadZone({
  proofImage,
  onPaste,
  onDrop,
  onRemove,
  fileInputRef,
}: ProofUploadZoneProps) {
  return (
    <div onPaste={onPaste}>
      {proofImage ? (
        <div className="relative rounded-lg border border-surface-700/40 overflow-hidden">
          <img
            src={proofImage.preview}
            alt="Proof screenshot"
            className="w-full max-h-40 object-cover"
          />
          <button
            type="button"
            onClick={onRemove}
            className="absolute top-2 right-2 h-6 w-6 rounded-full bg-surface-900/80 flex items-center justify-center hover:bg-surface-900 transition-colors"
          >
            <X className="h-3 w-3 text-surface-400" />
          </button>
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-surface-900/80 to-transparent px-3 py-2">
            <p className="text-[10px] text-surface-400 truncate">{proofImage.file.name}</p>
          </div>
        </div>
      ) : (
        <div
          onDragOver={(e) => e.preventDefault()}
          onDrop={onDrop}
          onClick={() => fileInputRef.current?.click()}
          className="flex items-center gap-3 rounded-lg border border-dashed border-surface-600/40 bg-surface-800/30 px-4 py-3 cursor-pointer transition-colors hover:border-surface-500/50 hover:bg-surface-800/50"
        >
          <ImagePlus className="h-4 w-4 text-surface-500 shrink-0" />
          <div className="min-w-0 flex-1">
            <p className="text-[11px] text-surface-400">
              Attach screenshot proof <span className="text-surface-600">(optional)</span>
            </p>
            <p className="text-[10px] text-surface-600 mt-0.5">
              Drop image, browse, or paste from clipboard
            </p>
          </div>
          <Upload className="h-3.5 w-3.5 text-surface-600 shrink-0" />
        </div>
      )}
    </div>
  );
}
